<template>
  <div class="kee-breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: getIfClientDrawerTag ? '/businessHome?drawerTag=1' : '/businessHome' }">{{ $t('home') }}</el-breadcrumb-item>
      <el-breadcrumb-item v-for="item in list" :key="item.path" :to="{ path: item.path }">
        {{ $t(item.title || item.meta.title) }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      list: []
    }
  },
  computed: {
    ...mapGetters('common', {
      getIfClientDrawerTag: 'getIfClientDrawerTag',
    }),
  },
  mounted() {
    if(this.$route.matched[1].name === "keeListNew") {
      this.list = [
        {
          title: this.$route.meta.title,
          path: this.$route.fullPath,
          name: this.$route.name
        }
      ]
    } else {
      this.list = this.$route.matched
    }
  }
}
</script>

<style>
.kee-breadcrumb .el-breadcrumb {
  font-size: 16px !important;
}
</style>
